import { playMessageSound } from 'pages/Settings/Components/Notifications/soundPlayer';

export const getPayload = (message) => {
  // Supports:
  // - { type: 'proposal', ... }
  // - { type: { type: 'proposal', ... } }
  return message && typeof message.type === 'object' && message.type !== null
    ? message.type
    : message;
};

export const playNotificationSound = (message) => {
  const payload = getPayload(message);
  if (payload?.type === 'proposal') {
    playMessageSound();
  }
};
